import { cn } from "@/shared/cn";
import { sanitiseDisplay } from "@/shared/forms/sanitise-display";
import { decodeHtmlEntities } from "@/features/intelligence/lib/html-entities";
import { guardPiiPlaceholders } from "@/features/intelligence/lib/pii-placeholder";
import { MarkdownProse } from "@/features/intelligence/components/MarkdownProse";
import { useTranslation } from "@/shared/i18n/LocaleProvider";
import type { ChatMessage as ChatMessageData } from "@/features/intelligence/lib/message";
import { fontSizeVar } from "@/shared/ui/type-scale";

export interface ChatMessageProps {
  message: ChatMessageData;
}

export function ChatMessage({ message }: ChatMessageProps) {
  const { t } = useTranslation();

  if (message.role === "advisor") {
    return (
      <div className="flex min-w-0 justify-end">
        <div
          className={cn(
            "max-w-[80%] rounded-[18px_18px_6px_18px] bg-(--fill)",
            "px-[15px] py-[10px] text-md leading-[1.6] text-(--ink) [overflow-wrap:anywhere]",
          )}
        >
          <MarkdownProse text={message.text} />
        </div>
      </div>
    );
  }

  const guarded = guardPiiPlaceholders(
    decodeHtmlEntities(sanitiseDisplay(message.text)),
    t("thread.piiRedacted"),
  );
  return (
    <div className="min-w-0 text-md leading-[1.65] text-(--ink)">
      <MarkdownProse text={guarded.text} />
      {guarded.hits > 0 && (
        <p
          className="mt-[16px] text-[var(--color-text-muted)]"
          style={{
            fontFamily: "var(--font-display)",
            fontSize: fontSizeVar("xs"),
            lineHeight: "150%",
          }}
        >
          {t("thread.piiRedactedHint")}
        </p>
      )}
    </div>
  );
}
